import { useCallback, useEffect, useMemo, useState } from "react";
  
import { GridValueGetterParams, GridColDef, GridActionsCellItem } from "@mui/x-data-grid";

const ReceiptList = () => {
    return( 
    <>
        Receipt Application works fine!!!
    </>
    )
}
export default ReceiptList;